<template>
 <ul class="nav nav-mobile-menu"> 
      <a href="/logout" class="dropdown-item text-danger">
        <i class="nc-icon nc-button-power"></i> Cerrar sesión
      </a>
  </ul> 
</template>
<script>
  import DropDown from 'src/components/Dropdown.vue'

  export default {
    components: {
      DropDown
    }
  }
</script>
<style>
</style>
